// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3BaBr","head":"Table_head__1c6-n","col":"Table_col__GO7fT"};